export default "__VITE_ASSET__C4VX3lcz__"